import { render, staticRenderFns } from "./drCfg.vue?vue&type=template&id=ba55e8c6&scoped=true&"
import script from "./drCfg.vue?vue&type=script&lang=js&"
export * from "./drCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba55e8c6",
  null
  
)

export default component.exports